module.exports = __webpack_public_path__ + "media/Varilux_PHYSIO.43f5797b.mp4";